import React, { useEffect, useRef, useState, useMemo } from "react";
import InputSearchPaymentLinks from "./inputSearchPaymentLinks";
import { useLocation, useNavigate } from "react-router-dom";
import AccordionPaymentLink from "./accordianPaymentLink";
import PaymentLinkEmptyScreen from "./paymentLinkEmptyScreen";
import BoxPayGrid from "../BoxPayGrid";
import ContentHeader from "../../reusableComponents/contentHeader/ContentHeader";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import OneTimePaymentDetailSchema from "./OneTimePaymentDetailSchema.js";
import MultiPaymentDetailSchema from "./MultiPaymentDetailSchema.js";
import { useAuth } from "../../context/API_Client";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import SettingsIcon from "@mui/icons-material/Settings";
import CustomDropdownList from "../../reusableComponents/customDropdownList/CustomDropdownList.js";
import { Skeleton } from "@mui/material";
import { colorBrandObject } from "../../../constants/brandings.js";
import { filterForPaymentLinkSchema } from "./PaymentLinkFilters.js";
import DynamicFilter from "../../reusableComponents/DynamicFilter/DynamicFilter.jsx";
import { fortmatTimezoneToUTC, PAGE_LIST } from "../utils/utils.js";
import TabSchema from "../tabSchema.js";
import MultiPaymentTransactionList from "./MultiPaymentTransactionList.js";

export default function TablePaymentLink({
  oneTimePaymentLinkData,
  multiplePaymentLinkData,
  isMultiPaymentLinkDataAvailable,
  timeZone,
  operationPermissions,
  getPaymentDetails,
  setTotalDataCount,
  totalDataCount,
  pageNo,
  pageLimit,
  setPageNo,
  setPageLimit,
  isMultiPaymentLinkTabActive,
  setIsMultiPaymentLinkTabActive
}) {
  const {
    getAllVisualizationData,
    merchantSettings,
    updateCheckoutSettings,
    getQrDetails,
    getAllModalData,
    getAllTransactionDetails
  } = useAuth();

  const tabSchema = [
    {
      label: 'One-Time Payments',
      value: '0',
      getActiveTab: (tab) => { handleTabChange(tab) }
    },
    {
      label: 'Multi-Payments',
      value: '1',
      getActiveTab: (tab) => { handleTabChange(tab) }
    }
  ];

  const paymentDetails = isMultiPaymentLinkDataAvailable && isMultiPaymentLinkTabActive ? multiplePaymentLinkData : oneTimePaymentLinkData;
  const [loading, setLoading] = useState(true);
  const [filteredPaymentLinkData, setFilteredPaymentLinkData] = useState([]);
  const [settingsAnchorEl, setSettingsAnchorEl] = React.useState(null);
  const [settings, setSettings] = useState();
  const [version, setVersion] = useState();
  const [downloadQrData, setDownloadQrData] = useState("");
  const open = Boolean(settingsAnchorEl);
  const [businessUnitData, setBusinessUnitData] = useState(null);
  const firstUpdateRef = useRef(true);
  const [filterModalData, setFilterModalData] = useState([]);
  const [filterDateData, setFilterDateData] = useState([]);
  const memoisedSearchbarModalData = useMemo(() => filterModalData, [filterModalData])
  const memoisedDateData = useMemo(() => filterDateData, [filterDateData])
  const [attributeName, setAttributeName] = useState("");
  const [attributeValue, setAttributeValue] = useState("");
  const [showDrawerForTransactionDetail, setShowDrawerForTransactionDetail] = useState(false);
  const [multiPaymentAllTransactionList, setMultiPaymentAllTransactionList] = useState([]);
  const [isTransactionListLoading, setIsTransactionListLoading] = useState(true);
  const paymentLinkTokenRef = useRef();
  const paymentLinkTransactionFilterRef = useRef();
  const selectedPaymentLinkRef = useRef();
  const firstUpdateForTransactionListRef = useRef(true);
  const [totalDataCountForTransactions, setTotalDataCountForTransactions] = useState(100);
  const [pageNoForTransactions, setPageNoForTransactions] = useState(1);
  const [pageLimitForTransactions, setPageLimitForTransactions] = useState(PAGE_LIST[2]);

  const handleTabChange = (tab) => {
    setIsMultiPaymentLinkTabActive(tab !== '0');
  }

  const updateAllPspSchemaArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);

    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };

  const handleUpdateAllSchemaMethods = (schema, allModalData) => {
    const objectBUIdToUpdate = "context.legalEntity.code";
    let businessUnitData = allModalData.find(d => d.filterName === objectBUIdToUpdate);
    updateAllPspSchemaArray(schema, objectBUIdToUpdate, businessUnitData?.filterValues || []);

    const objectUserIdToUpdate = "userId";
    let userIdData = allModalData.find(d => d.filterName === objectUserIdToUpdate);
    updateAllPspSchemaArray(schema, objectUserIdToUpdate, userIdData?.filterValues || []);

    const objectStatusToUpdate = "status";
    let statusData = allModalData.find(d => d.filterName === objectStatusToUpdate);
    updateAllPspSchemaArray(schema, objectStatusToUpdate, statusData?.filterValues || []);
  }

  useEffect(() => {
    getAllModalData(
      function (data) {
        setBusinessUnitData(data?.legalEntities);
        getAllVisualizationData(
          "filters/payment_links",
          {},
          function (data) {
            let schema = filterForPaymentLinkSchema;
            const formattedData = data?.map(el => {
              if (el.filterName == "legalEntity") {
                return { ...el, filterName: "context.legalEntity.code" }
              }
              return el
            })
            handleUpdateAllSchemaMethods(schema, formattedData);
          },
          function (errorMsg) {
            customToast("error", "high", errorMsg);
          }
        );
      },
      function (errorMsg) { }
    );
  }, []);

  const currentDate = new Date();
  let toDate = new Date();
  toDate.setHours(23, 59, 59, 999);
  let fromDate = new Date(toDate);
  fromDate.setMonth(fromDate.getMonth() - 13);
  fromDate.setHours(0, 0, 0, 0);

  const navigate = useNavigate();
  const handleFabClick = () => {
    navigate("/paymentLinks/createPaymentlink");
  };
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  useEffect(() => {
    merchantSettings(
      (data) => {
        setSettings(data);
        setVersion(data?.version);
      },
      (errMsg) => {
        customToast("error", "high", errMsg);
      }
    );
  }, []);
  const updateFunction = (id, value) => {
    let payLoad = settings;
    if ("version" in payLoad) delete payLoad["version"];
    payLoad.requiresProductCode = value;
    updateCheckoutSettings(
      { ...payLoad, version },
      function (data) {
        localStorage.setItem("merchantSettings", JSON.stringify(data));
        setSettings(data);
        setVersion(data?.version);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  };
  const updateNotifyViaSmsFunction = (id, value) => {
    let payLoad = settings;
    if ("version" in payLoad) delete payLoad["version"];
    payLoad.notifyViaSmsEnabled = value;
    updateCheckoutSettings(
      { ...payLoad, version },
      function (data) {
        localStorage.setItem("merchantSettings", JSON.stringify(data));
        setSettings(data);
        setVersion(data?.version);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  };
  const updateProductDescriptionEditableFunction = (id, value) => {
    let payLoad = settings;
    if ("version" in payLoad) delete payLoad["version"];
    payLoad.editableProductDescription = value;
    updateCheckoutSettings(
      { ...payLoad, version },
      function (data) {
        localStorage.setItem("merchantSettings", JSON.stringify(data));
        setSettings(data);
        setVersion(data?.version);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  };
  const handleClick = (event) => {
    setSettingsAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setSettingsAnchorEl(null);
  };
  useEffect(() => {
    if (paymentDetails != null) {
      setLoading(false);
    }
  }, [paymentDetails]);
  useEffect(() => {
    if (paymentDetails?.length) {
      const updatedPaymentDetails = paymentDetails?.map((payment) => {
        const businessUnit = businessUnitData?.find(
          (unit) => unit?.code === payment?.context?.legalEntity?.code
        );
        return {
          ...payment,
          businessUnitName: businessUnit ? businessUnit.name : null,
        };
      });
      setFilteredPaymentLinkData(updatedPaymentDetails);
    } else {
      setFilteredPaymentLinkData([])
    }
  }, [paymentDetails, businessUnitData]);
  const getDate = () => {
    const currentDate = new Date();
    let fromDate, toDate;
    if (filterDateData?.selectedValue) {
      const { fromDate: formattedFromDate, toDate: formattedToDate } =
        fortmatTimezoneToUTC(
          filterDateData?.selectedValue,
          filterDateData?.finalStartDate,
          filterDateData?.finalEndDate
        );
      fromDate = formattedFromDate;
      toDate = formattedToDate;
    } else {
      const currentYear = currentDate.getFullYear();
      toDate = new Date();
      toDate.setHours(23, 59, 59, 999);
      fromDate = new Date(toDate);
      fromDate.setMonth(fromDate.getMonth() - 13);
      fromDate.setHours(0, 0, 0, 0);
    }
    return { toDate, fromDate }
  }
  const getFilterObj = (attrName, values) => {
    let search = [];
    if (Array.isArray(values) || values?.length > 0) {
      search.push({
        attrName: attrName,
        operator: "containsIgnoreCase",
        values: [values],
      });
    }

    let filters = {
      multipleTransaction: isMultiPaymentLinkTabActive
    };

    filterModalData.forEach((item) => {
      filters[item.id] = item.value;
    });
    return { filters, search }
  }
  function getFilteredData(attrName, values) {
    let { fromDate, toDate } = getDate();
    let { filters, search } = getFilterObj(attrName, values);
    if (search) {
      setLoading(true);
      getAllVisualizationData(
        "payment_links",
        {
          fromDate,
          toDate,
          sort: {
            addedTimestamp: "desc",
          },
          advancedAttributeFilters: search,
          attributeFilters: filters,
          limit: pageLimit, // pagination
          offset: (pageNo - 1) * pageLimit, // pagination
        },
        function (paymentDetails) {
          const updatedPaymentDetails = paymentDetails?.points?.map(
            (payment) => {
              const businessUnit = businessUnitData?.find(
                (unit) => unit?.code === payment?.context?.legalEntity?.code
              );

              return {
                ...payment,
                businessUnitName: businessUnit ? businessUnit.name : null,
              };
            }
          );
          setTotalDataCount(paymentDetails.totalCount);
          setFilteredPaymentLinkData(updatedPaymentDetails);
          setLoading(false);
        },
        (errorMsg) => {
          setLoading(false);
          customToast("error", "high", errorMsg);
        },
        operationPermissions
      );
    } else {
      const updatedPaymentDetailsData = paymentDetails?.map((payment) => {
        const businessUnit = businessUnitData?.find(
          (unit) => unit?.code === payment?.context?.legalEntity?.code
        );

        return {
          ...payment,
          businessUnitName: businessUnit ? businessUnit.name : null,
        };
      });
      setFilteredPaymentLinkData(updatedPaymentDetailsData);
    }
  }
  useEffect(() => {
    if (firstUpdateRef.current) {
      firstUpdateRef.current = false;
      return;
    }
    getFilteredData(attributeName, attributeValue);
  }, [pageNo, pageLimit, memoisedSearchbarModalData, memoisedDateData]);
  const handleSearchData = (attrName, values) => {
    setPageNo(1);
    getFilteredData(attrName, values);
    setAttributeName(attrName);
    setAttributeValue(values);
  };
  const handleEditButton = (data) => {
    navigate("/paymentLinks/editPaymentlink", { state: { editData: data } });
  };
  const handleDuplicateButton = (data) => {
    navigate("/paymentLinks/createPaymentlink", {
      state: { duplicateData: data },
    });
  };
  const handleSearchbarModalData = (data) => {
    setFilterModalData(data);
  };
  const handleDateModalData = (date) => {
    setFilterDateData(date)
  };
  const handleDownloadQr = (data) => {
    const downloadQrToken = data?.token;
    getQrDetails({
      downloadQrToken,
      success: function (data) {
        setDownloadQrData(data);
      },
      error: function (errMsg) {
        customToast("error", "high", errMsg);
      },
    });
  };
  useEffect(() => {
    if (downloadQrData) {
      const qrImageSrc = `data:image/gif;base64,${downloadQrData?.trackingUrls?.QR}`;

      const image = new Image();
      image.src = qrImageSrc;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0);
        const format = "png";
        const dataUrl = canvas.toDataURL(`image/${format}`);
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `qr_code.${format}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        customToast("success", "medium", "QR downloaded successfully");
      };

      image.onerror = () => {
        customToast("error", "medium", "Failed to load QR code image");
      };
    }
  }, [downloadQrData]);
  const handleMultipleTransactionDrawer = (data) => {
    selectedPaymentLinkRef.current = data;
    const { token } = selectedPaymentLinkRef.current;
    setShowDrawerForTransactionDetail(true);
    setIsTransactionListLoading(true);
    paymentLinkTokenRef.current = token;
    let { fromDate, toDate } = getDate();
    let reqData = {
      fromDate: fromDate,
      toDate: toDate,
      advancedAttributeFilters: [
        {
          attrName: "caller.token",
          operator: "eq",
          values: [token]
        }
      ],
      limit: pageLimitForTransactions, // pagination
      offset: (pageNoForTransactions - 1) * pageLimitForTransactions // pagination
    }
    paymentLinkTransactionFilterRef.current = reqData;
    getAllTransactionDetails(reqData, function (resp) {
      setMultiPaymentAllTransactionList({ paymentLinkData: data, paymentLinkTransactionData: resp.points })
      setIsTransactionListLoading(false);
      setTotalDataCountForTransactions(resp.totalCount);
    },
      function (errorMsg) {
        setPaymentError(errorMsg);
        setIsTransactionListLoading(false);
      },
      operationPermissions
    );
  };

  useEffect(() => {
    if (firstUpdateForTransactionListRef.current) {
      firstUpdateForTransactionListRef.current = false;
      return;
    }
    handleMultipleTransactionDrawer(selectedPaymentLinkRef.current)
  }, [pageLimitForTransactions, pageNoForTransactions])

  return (
    <>
      <div className="content-wrapper" style={{ background: "white" }}>
        <section className="content paymentDivMobilePadding">
          <div className="paymentMainDivCreate">
            <ContentHeader
              firstHeading="Payment Links"
              secondHeading="Create and share payment links effortlessly to collect payments from your customers anytime, anywhere"
              buttonPermissions={[
                operationPermissions?.createPaymentLink,
                operationPermissions?.updateMerchantSetting,
              ]}
              secondaryButtonPermissions={[
                operationPermissions?.createPaymentLink,
              ]}
              icon={
                <InsertLinkIcon
                  sx={{
                    color: colorBrandObject.sideBarSelectedOptionBackground,
                  }}
                />
              }
              secondaryButtonText="Create Link"
              secondaryButtonType="primary"
              secondaryButtonSize="md"
              secondaryButtonVariant="contained"
              secondaryButtonOnClick={() =>
                navigate("/paymentLinks/createPaymentlink")
              }
              showFabButton={true}
              handleFabClick={handleFabClick}
              fabButtonText="Create Link"
              buttonText={
                <SettingsIcon sx={{ height: "20px", width: "20px" }} />
              }
              buttonType="primary"
              buttonSize="md"
              buttonVariant="outlined"
              buttonId="settings-button"
              iconButton={true}
              buttonOnclick={(event) => handleClick(event)}
            />
            <div key={isMultiPaymentLinkTabActive}>
              {
                isMultiPaymentLinkDataAvailable && (
                  <div className="mt-3" style={{ marginBottom: '-1.5rem' }}>
                    <TabSchema tabs={tabSchema} tabKey="paymentLinkTab" />
                  </div>
                )
              }
              {settings && (
                <CustomDropdownList
                  open={open}
                  handleClose={handleClose}
                  anchorEl={settingsAnchorEl}
                  header={"Payment Link Settings"}
                  headerLogo={<InsertLinkIcon />}
                  content={[
                    {
                      header: "Product type mandatory",
                      toolTipContent:
                        "This setting will make Product Type mandatory for all the payment links created in the future",
                      type: "switch",
                      updateId: "isPaymentTypeMandatory",
                      initialState: settings?.requiresProductCode,
                      updateFunction: updateFunction,
                    },
                    {
                      header: "Notify via SMS",
                      toolTipContent:
                        "This setting will only be enabled for Indian mobile number",
                      type: "switch",
                      updateId: "notifyViaSmsEnabled",
                      initialState: settings?.notifyViaSmsEnabled,
                      updateFunction: updateNotifyViaSmsFunction,
                    },
                    {
                      header: "Product description editable",
                      toolTipContent:
                        "This setting will make Product description editable for all the payment links created in the future",
                      type: "switch",
                      updateId: "editableProductDescription",
                      initialState: settings?.editableProductDescription,
                      updateFunction: updateProductDescriptionEditableFunction,
                    },
                  ]}
                />
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div style={{ marginTop: "32px" }} className="inputField">
                  <InputSearchPaymentLinks
                    searchData={handleSearchData}
                    tokenData={token}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  margin: "24px 0",
                  justifyContent: "flex-start",
                  width: "100%",
                }}
              >
                <DynamicFilter
                  value={"value"}
                  filteredSchema={filterForPaymentLinkSchema}
                  handleSearchbarModalData={handleSearchbarModalData}
                  handleDateModalData={handleDateModalData}
                />
              </div>
              {filteredPaymentLinkData && settings ? (
                <div className="paymentLinkTable">
                  <BoxPayGrid
                    schema={
                      isMultiPaymentLinkTabActive ?
                        MultiPaymentDetailSchema(
                          timeZone,
                          settings,
                          handleEditButton,
                          handleDuplicateButton,
                          handleDownloadQr,
                          getPaymentDetails,
                          handleMultipleTransactionDrawer
                        )
                        :
                        OneTimePaymentDetailSchema(
                          timeZone,
                          settings,
                          handleEditButton,
                          handleDuplicateButton,
                          handleDownloadQr,
                          getPaymentDetails
                        )
                    }
                    data={filteredPaymentLinkData}
                    loader={loading}
                    customPagination={true}
                    pageNo={pageNo}
                    setPageNo={setPageNo}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    totalDataCount={totalDataCount}
                  />
                </div>
              ) : (
                <Skeleton
                  variant="text"
                  width="60%"
                  height={40}
                  style={{ marginBottom: 10 }}
                />
              )}

              {paymentDetails?.length ? (
                <div className="paymentLinkPhonecontainer">
                  <AccordionPaymentLink
                    data={filteredPaymentLinkData}
                    timeZone={timeZone}
                    operationPermissions={operationPermissions}
                  />
                </div>
              ) : (
                <div className="paymentLinkPhonecontainer">
                  <PaymentLinkEmptyScreen />
                </div>
              )}
            </div>
          </div>
        </section>
        <MultiPaymentTransactionList
          paymentLinkToken={paymentLinkTokenRef.current}
          multiPaymentAllTransactionList={multiPaymentAllTransactionList}
          setShowDrawerForTransactionDetail={setShowDrawerForTransactionDetail}
          showDrawerForTransactionDetail={showDrawerForTransactionDetail}
          isTransactionListLoading={isTransactionListLoading}
          paymentLinkTransactionFilter={paymentLinkTransactionFilterRef.current}
          pageNo={pageNoForTransactions}
          setPageNo={setPageNoForTransactions}
          pageLimit={pageLimitForTransactions}
          setPageLimit={setPageLimitForTransactions}
          totalDataCount={totalDataCountForTransactions}
        />
      </div>
    </>
  );
}
